import styled from "@emotion/styled";

export default function Image3() {
  return <RootWrapperImage3 />;
}

const RootWrapperImage3 = styled.div`
  width: 1440px;
  height: 383px;
  background: url(https://s3-alpha-sig.figma.com/img/9594/2d22/6288356a23aa69c24625ea6b6b9dedbc?Expires=1748822400&Key-Pair-Id=APKAQ4GOSFWCW27IBOMQ&Signature=Ux5iSj2my7u6GgTW-8lIXGOjtxtb-N3vwSfrTCSh0~ZmibbCIErW18zm2n6SlPIEuwxgNpa6RFkm2QADe~MI-yx9szzJpRzfQJQfz8SIc4uRH~DzRbSqHjkbMyFhTrbOKTZmOCRbQ2fTV2UnNUoGeUjolNokmq~vBXdLpKqVf19-x~oMyXAGBNoYfOiOWoMb23iqj5q5Xs8s3658bNBnaLn5yoeDuGKkg-uFdE45y8-~5q50n~SV~3pBnsVXfYGGUvPhPP6tRfC4JLCkB72f86hxFYJyr7u2Zm8W9l5JnO72~5prhqWjODL~J~C1G~gbqtPJc00Nmijh2ESwkG8PFg__);
  background-repeat: no-repeat;
  background-size: cover;
  background-position: center;
`;
